import React from 'react';
import c from 'classnames';

import { LinkButton, Stack, Typography, TypographyColors } from '@lyearn/ui';

import { HeaderBannerProps } from './types';

const BANNER_TYPE = {
  purple: {
    fillColorToken: 'icon-purple',
    color: 'text-text-purple',
    background: 'bg-bg-purple-light',
  },
  error: {
    fillColorToken: 'icon-error',
    color: 'text-text-error',
    background: 'bg-bg-error-light',
  },
  black: {
    fillColorToken: 'icon-placeholder',
    color: 'text-text-white',
    background: 'bg-focus-primary',
  },
  archived: {
    fillColorToken: 'icon-secondary',
    color: 'text-text-secondary',
    background: 'bg-bg-tertiary',
  },
  warning: {
    fillColorToken: 'icon-warning',
    color: 'text-text-warning',
    background: 'bg-bg-warning-light',
  },
  success: {
    fillColorToken: 'icon-success',
    color: 'text-text-success',
    background: 'bg-bg-success-light ',
  },
};

const HeaderBanner: React.FC<HeaderBannerProps> = (props) => {
  const { className, title, appearance, StartIcon, Avatars, action } = props;
  const banner = BANNER_TYPE[appearance];

  return (
    <Stack
      className={c('sticky z-10 w-full p-10', banner.background, className)}
      justifyContent="center">
      <Stack alignItems="center">
        {StartIcon ? (
          <StartIcon className="h-20 w-20 me-8" fillColorToken={banner.fillColorToken} />
        ) : null}
        {Avatars ? Avatars : null}
        <Typography color={banner.color as TypographyColors} variant="body-short-02">
          {title}
        </Typography>
        {action ? (
          <LinkButton onClick={action.onAction}>
            <Typography
              className="pl-8"
              color={banner.color as TypographyColors}
              variant="label-02">
              {action.title}
            </Typography>
          </LinkButton>
        ) : null}
      </Stack>
    </Stack>
  );
};

export default HeaderBanner;
